import React from 'react';
import { Box, Grid, Link, Typography } from '@mui/material';
import { FaFacebookF, FaInstagram, FaYoutube } from 'react-icons/fa';
import { footerContactNum, socialLinks } from '../constants';
import { NavLink } from 'react-router-dom';

const ToolbarArea = () => {
  return (
    <Box
      component="section"
      className='topbar'
      sx={{
        borderBottom: '1px solid #ddd',
        py: 1,
        display: { xs: 'none', md: 'flex' }, // similar to mobile-hide-topbars
      }}
    >
      <Box
        className="container"
        sx={{
          maxWidth: 1200,
          mx: 'auto',
          px: 2,
        }}
      >
        <Grid container alignItems="center" spacing={2}>
          {/* Left side (phone + email) */}
          <Grid item xs={12} md={8}>
            <Box sx={{ display: 'flex', gap: 4 }}>
              {/* Phone */}
                {footerContactNum.map(value => (
                    <Box key={value.id} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box component="span" className="icon">
                            {/* Replace with your icon or svg */}
                            {value.icon}
                        </Box>
                        <Link href={value.value} underline="none" color="text.white" sx={{ fontWeight: 500 }}>
                            {value.text}
                        </Link>
                    </Box>
                ))}
              
            </Box>
          </Grid>

          {/* Right side (social icons) */}
          <Grid item xs={12} md={4} sx={{textAlign:"right"}}>
            <Box sx={{ textAlign: 'right' }}>

                {socialLinks.map(value =>(
                    <Link
                        key={value.id}
                        href={value.url} 
                        target="_blank"
                        rel="noopener noreferrer"
                        color="inherit"
                        sx={{ mx: 1, fontSize: 20 }}>
                            {value.icon}
                    </Link>
                ))}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default ToolbarArea;
